import useSortedPerAvailabilityList from '../hooks/use-sorted-per-availability-list';

export const getSortedGroups = <T extends TCategories | TPart[]>(
  groups: T
): T => {
  let groupsSort: TCategories = [];
  groupsSort = useSortedPerAvailabilityList(groups) as TCategories;

  groupsSort.map((group) => {
    const partsSort = Object.entries(group.parts).reduce(
      (finalParts, [partIndex, parts]) => {
        const sortedParts = useSortedPerAvailabilityList(parts);
        return { ...finalParts, [partIndex]: sortedParts };
      },
      {} as typeof group.parts
    );

    return { ...group, parts: partsSort };
  });

  groupsSort.forEach((categ) => {
    const totalPartsArray = Object.values(categ.parts).flat();
    const isNotAllowed = totalPartsArray.filter((p) => p.is_allowed === false);
    const isProNotAllowed = totalPartsArray.filter(
      (p) => p.is_pro_allowed === false
    );
    const isProAllowed = totalPartsArray.filter(
      (p) => p.is_pro_allowed === true
    );

    if (
      isNotAllowed.length === totalPartsArray.length &&
      isProNotAllowed.length === totalPartsArray.length
    ) {
      categ.isNotAllowedFullCategory = true;
    } else {
      if (isProAllowed.length > 0 && isNotAllowed.length > 0) {
        categ.someNotAllowed = true;
      }
    }
  });

  return groupsSort as T;
};

export const getSortedProductsPerGroups = <T extends TCategories | TPart[]>(
  groups: T
): T => {
  let groupsSort: TCategories = [];
  groupsSort = useSortedPerAvailabilityList(groups) as TCategories;

  return groupsSort as T;
};
